import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Container, Typography } from "@mui/material";

import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";

import digitalFloraData from "../../data/digitalFloraData";

import HeroSection from "./HeroSection";
import BotanicalProfile from "./BotanicalProfile";
import Taxonomy from "./Taxonomy";
import Morphology from "./Morphology";
import DigitalIdentification from "./DigitalIdentification";
import Phytochemicals from "./Phytochemicals";
import MedicinalImportance from "./MedicinalImportance";
import EconomicImportance from "./EconomicImportance";
import ConservationStatus from "./ConservationStatus";
import References from "./References";

function FloraDetails() {
  const { id } = useParams();

  // Scroll to top whenever a new plant page opens
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [id]);

  const plant = digitalFloraData.find((item) => item.id === id);

  if (!plant) {
    return (
      <>
        <Navbar />

        <Container maxWidth="md">
          <Typography
            variant="h4"
            align="center"
            sx={{
              mt: 10,
              fontWeight: 700,
              color: "error.main",
            }}
          >
            🌿 Plant Not Found
          </Typography>
        </Container>

        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <Box
        sx={{
          minHeight: "100vh",
          py: { xs: 3, md: 6 },
          position: "relative",
          overflow: "hidden",
          background: `
            radial-gradient(circle at top left, rgba(129,199,132,.18), transparent 35%),
            radial-gradient(circle at bottom right, rgba(56,142,60,.12), transparent 35%),
            linear-gradient(135deg,#edf7ed 0%,#f8fff8 45%,#ffffff 100%)
          `,
        }}
      >
        {/* Decorative botanical background */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            opacity: 0.04,
            pointerEvents: "none",
            backgroundImage:
              "radial-gradient(#2e7d32 1.5px, transparent 1.5px)",
            backgroundSize: "60px 60px",
          }}
        />

        <Container
          maxWidth="xl"
          sx={{
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* Hero Section */}
          <HeroSection plant={plant} />

          {/* Botanical Profile */}
          <BotanicalProfile plant={plant} />

          {/* Taxonomy */}
          <Taxonomy plant={plant} />

          {/* Morphology */}
          <Morphology plant={plant} />

          {/* Digital Identification */}
          <DigitalIdentification plant={plant} />

          {/* Phytochemicals */}
          <Phytochemicals plant={plant} />

          {/* Medicinal Importance */}
          <MedicinalImportance plant={plant} />

          {/* Economic Importance */}
          <EconomicImportance plant={plant} />

          {/* Conservation Status */}
          <ConservationStatus plant={plant} />

          {/* References */}
          <References plant={plant} />
        </Container>
      </Box>

      <Footer />
    </>
  );
}

export default FloraDetails;